import type { colors } from './colors';

type Color = keyof typeof colors;

export function convertToColorArrays(
  colorsToConvert: typeof colors,
): Record<Color, [string, string, string, string, string, string, string, string, string, string]> {
  return Object.keys(colorsToConvert).reduce(
    (acc, color) => {
      const key = color as Color;

      return {
        ...acc,
        [key]: Object.values(colorsToConvert[key]),
      };
    },
    {} as Record<
      Color,
      [string, string, string, string, string, string, string, string, string, string]
    >,
  );
}
